module.exports = __webpack_public_path__ + "static/fonts/DaimlerCAC-Regular.a500b6bc.eot";